// extracted by mini-css-extract-plugin
module.exports = {"component":"Shadow_component__1eMdn","animation":"Shadow_animation__aAYNM","visible":"Shadow_visible__m0-t5"};